import { parseHttpUrl } from '#pplx/frontend/apps/ask/canvas-shared/externalUrl.js';
// Kept as a leaf module so `assetHelpers` can consume it without a cycle.
export const isExternalUrlAsset = (asset) => asset.asset_type === 'EXTERNAL_URL' || asset.asset_type === 'PULL_REQUEST';
/**
 * The validated outbound target for a link artifact, or null when the stored
 * location is not an http(s) URL. Callers treat null as "not openable" rather
 * than falling back to the raw value, since the location originates from a
 * model and is untrusted.
 */
export function getExternalUrlAssetHref(asset) {
    return parseHttpUrl(asset.location)?.href ?? null;
}
//# sourceMappingURL=externalUrlAsset.js.map